import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function AgronomySupportPublic() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Agronomy Support | Kryzen Biotech Crop Advisory & Farm Success Services"
        description="Kryzen Biotech offers expert agronomy support alongside protected farming systems. From soil health to crop yield optimization, we help farmers adopt resilient and profitable farming practices."
        keywords="agronomy support, kryzen biotech, farm advisory services, crop yield optimization, soil health improvement, smart farming practices, climate-resilient agriculture, protected farming support"
        canonical="https://alpha.kryzen.com/kryzen-agronomy-support"
        ogTitle="Agronomy Support | Kryzen Biotech Crop Advisory & Farm Success Services"
        ogDescription="Go beyond infrastructure with Kryzen's full-service agronomy support — improve soil health, boost yields, and implement cost-effective, climate-resilient cultivation methods."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752467867/agronomywiki_ciaz1q.png"
        twitterTitle="Agronomy Support | Kryzen Biotech Crop Advisory & Farm Success Services"
        twitterDescription="Kryzen Biotech’s agronomy team partners with farmers to ensure crop success — from soil management to smart cultivation practices that boost profitability and resilience."
      />
      <div>
        <Slider
          heding={"Agronomy Support"}
          paragraph={
            "At Kryzen Biotech, we go beyond providing protected farming infrastructure — we offer comprehensive agronomy support to ensure farmers succeed at every stage of cultivation."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              Kryzen Agronomy Support
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              At Kryzen Biotech, we go beyond providing protected farming
              infrastructure — we offer comprehensive agronomy support to ensure
              farmers succeed at every stage of cultivation. Our expert agronomy
              team works hand-in-hand with growers to optimize soil health,
              improve crop yields, and adopt climate-resilient, cost-effective
              farming practices.
            </motion.p>
          </div>
          <div className="text-center py-2 ">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
            >
              Our Agronomy Services Include
            </motion.h1>

            <hr></hr>
          </div>
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-6">
              <div
                className=" border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary text-center">
                    Soil and Nutrient Management
                  </h5>
                  <hr></hr>
                  <p style={{ fontSize: "18px" }}>
                    <b>Soil Testing & Mapping :</b> Analyze pH levels, organic
                    matter content, and nutrient availability.<br></br>
                    <br></br>
                    <b>Fertilizer Management :</b>Proper application of
                    macronutrients (N-P-K) and micronutrients (zinc, boron,
                    iron) based on crop stage and soil health.<br></br>
                    <br></br>
                    <b>Organic Amendments :</b> Compost, vermicompost, biochar,
                    and green manure are added to improve soil structure and
                    microbial life.<br></br>
                    <br></br>
                    <b>Cover Cropping :</b> Legumes and grasses are grown
                    off-season to prevent erosion, suppress weeds, and fix
                    nitrogen.<br></br>
                    <br></br>
                    <b>Crop Rotation :</b> Alternating crops each season to
                    reduce soil fatigue and break pest/disease cycles.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className=" border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary text-center">
                    Crop Production and Agronomic Planning
                  </h5>
                  <hr></hr>
                  <p style={{ fontSize: "18px" }}>
                    <b>Seed Selection :</b> Choosing high-yielding, drought- or
                    disease-tolerant varieties.<br></br>
                    <br></br>
                    <b>Planting Techniques :</b>Determining row spacing, sowing
                    depth, and plant population to optimize sunlight and
                    airflow.<br></br>
                    <br></br>
                    <b>Growth Monitoring :</b> Evaluating crop stages
                    (vegetative, flowering, fruiting) and adjusting inputs
                    accordingly.<br></br>
                    <br></br>
                    <b>Weed Control :</b> Manual weeding, herbicide application,
                    or intercropping to suppress unwanted plants.<br></br>
                    <br></br>
                    <b>Harvest Timing :</b> Determining the best harvest window
                    to maximize yield and quality while minimizing post-harvest
                    losses.
                  </p>
                </div>
              </div>
            </div>
            <hr></hr>

            {/* Right Column */}
            <div className="col-md-6">
              <div
                className=" border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary text-center">
                    Pest and Disease Management
                  </h5>
                  <hr></hr>
                  <p style={{ fontSize: "18px" }}>
                    <b>Pest Management :</b>
                    <br></br>
                    <br></br>
                    <ul>
                      <li>
                        <b>Monitoring Tools:</b>Sticky traps, light traps,
                        pheromone lures, and regular field scouting.
                      </li>
                      <li>
                        <b>Biological Controls:</b>Use of natural predators
                        (e.g., ladybugs, parasitic wasps) and microbial
                        insecticides like Bacillus thuringiensis (Bt).
                      </li>
                      <li>
                        <b>Cultural Practices:</b>Crop rotation, clean planting
                        material, and sanitation to break pest cycles.
                      </li>
                      <li>
                        <b>Chemical Controls:</b>Judicious use of pesticides
                        only when thresholds are crossed, reducing resistance
                        and residue risks.
                      </li>
                    </ul>
                  </p>
                  <p style={{ fontSize: "18px" }}>
                    <b>Disease Management :</b>
                    <br></br>
                    <br></br>
                    <ul>
                      <li>
                        <b>Seed Treatment :</b>Using fungicides and
                        biostimulants to prevent early-stage infections.
                      </li>
                      <li>
                        <b>Disease-Resistant Varieties :</b>Promoting cultivars
                        with resistance to common pathogens like powdery mildew,
                        rust, or bacterial wilt.
                      </li>
                      <li>
                        <b>Fungal/Bacterial Spray Protocols :</b>Well-timed
                        application of protectant and curative sprays.
                      </li>
                      <li>
                        <b>Climate Forecast Integration :</b> Using weather data
                        to predict and prepare for disease outbreaks.
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className=" border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary text-center">
                    Irrigation and Water Resource Management
                  </h5>
                  <hr></hr>
                  <p style={{ fontSize: "18px" }}>
                    <b>Drip Irrigation :</b> Delivers water directly to roots,
                    ideal for water-scarce regions.<br></br>
                    <br></br>
                    <b>Sprinkler Irrigation :</b>Provides even coverage,
                    especially useful in sandy soils.<br></br>
                    <br></br>
                    <b>Irrigation Scheduling :</b>Based on soil moisture data,
                    weather forecasts, and evapotranspiration rates.<br></br>
                    <br></br>
                    <b>Mulching :</b> Reduces water loss from evaporation and
                    suppresses weed growth.<br></br>
                    <br></br>
                    <b>Rainwater Harvesting :</b> Collecting and storing
                    rainwater for off-season or supplemental irrigation.
                  </p>
                </div>
              </div>
            </div>
            <hr></hr>
            <div className="col-md-6">
              <div
                className=" border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary text-center">
                    Farm Support and Extension Services
                  </h5>
                  <hr></hr>
                  <p style={{ fontSize: "18px" }}>
                    <b>On-field Technical Visits :</b> Agronomists inspect
                    fields, diagnose issues, and recommend actions.<br></br>
                    <br></br>
                    <b>Training Programs :</b>Sessions on nutrient management,
                    pest identification, equipment use, and safety.<br></br>
                    <br></br>
                    <b>Customized Crop Calendars :</b>Tailored schedules that
                    align with local climate and crop cycles.<br></br>
                    <br></br>
                    <b>Mobile App Integration :</b> Alerts for irrigation,
                    fertilizer, pesticide spraying, and weather events.<br></br>
                    <br></br>
                    <b>Farmer Feedback Loops :</b> Collecting data from farmers
                    to improve services and refine crop models.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className=" border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary text-center">
                    Sustainable & Climate-Smart Agronomy
                  </h5>
                  <hr></hr>
                  <p style={{ fontSize: "18px" }}>
                    <b>Drought-Resilient Crops :</b> Introducing varieties that
                    need less water and mature faster.<br></br>
                    <br></br>
                    <b>Carbon Farming :</b>Encouraging practices that store
                    carbon in soil (e.g., no-till farming, cover crops).
                    <br></br>
                    <br></br>
                    <b>Agroforestry :</b>Combining trees with crops to improve
                    biodiversity and resilience.<br></br>
                    <br></br>
                    <b>Precision Agriculture :</b> Using AI, GIS, and remote
                    sensing to optimize inputs and detect stress early.<br></br>
                    <br></br>
                    <b>Organic and Natural Farming :</b> Reducing chemical
                    dependence and improving soil and crop health.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterwithoutLogin></FooterwithoutLogin>
      </div>
    </>
  );
}

export default AgronomySupportPublic;
